export enum matterStyles {
    Normal=0,
    Unique = 1,
}